<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15Qjrdi/tc-custom/9781667445229.jpg?1680421234914" alt="This image is the cover for the book Guida completa per comprendere le Dommes della Cina continentale"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Guida completa per comprendere le Dommes della Cina continentale
      </h1>
      <p class="bookDescription body article font2">
        <p>Questo libro è stato scritto per uno scopo molto specifico e soprattutto per una nicchia molto specifica, che dovrebbe essere abbastanza evidente dal titolo. In poche parole, questo è per gli uomini sottomessi - - VERAMENTE sottomessi (al contrario di coloro che scelgono di "dominare dal basso") e dovrebbe essere letto con una mentalità simile a questa (se non siete in questa categoria). Uomini sottomessi che cercano di trovare la domme dei loro sogni - - o più precisamente la domme cinese dei loro sogni. Naturalmente, la maggior parte di ciò che viene menzionato NON è specifico per una particolare etnia - - ma ho trovato che vale di più per il sottogruppo etnico che ho menzionato. Molto di quello che dico potrebbe sembrare controverso. E allora, così sia. Non sono mai stato conosciuto (né di persona né nei miei libri) per girare intorno alle cose e NON dirle per quello che sono - semmai sono stato brutalmente onesto per tutta la mia vita e questo stesso stile permea nella mia scrittura in tutti i settori. Se tutto questo suona come uno stile a cui vorreste prendere parte, lanciatevi!<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mike Watson, Chiara Giuffrè
      </h2>
      
      <p class="authorDescription body article">Mike Watson è uno scrittore, imprenditore e appassionato di fitness. "Sfornando" libri come e quando la "volontà lo coglie", trova anche il tempo per dedicarsi ad altre attività di scrittura e di business, oltre ad avere la passione per il fitness.<br/> La maggior parte, se non TUTTE le sue opere, sono state scritte in un "flusso di coscienza", oltre a un modo brutalmente onesto, direttamente dal cuore. Come dice nei suoi libri (beh, nella maggior parte) - "la realtà miscelata con una sana dose di licenza creativa (o pepe) è ciò che funziona meglio" - ed è seguendo questa metafora che la maggior parte delle sue opere sono state scritte. È l'autore di "Serving an Indian Goddess", "Meeting Ms. Chen", "Owned by Madam Aa Ling" e molti altri libri femdom bestselling e corsi di istruzione. Maggiori informazioni sono disponibili sul suo blog all'indirizzo www.spicyanderoticfetish.com. Può essere contattato all'indirizzo info@spicyanderoticfetish.com (o in alternativa, spicyanderoticfetish@gmail.com).<br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Mike Watson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1ecbe566